/*
 * This is only to allow us to pass in a mocked window for the unit tests.
 */
define('window', [], function () {
    'use strict';

    return window;
});

